import { navItems } from '../lib/constants/resources';

export function getActiveNavPath(selectedSegment: string | null): string {
  const defaultPath = navItems[0]?.href ?? '';

  if (selectedSegment === null) {
    return defaultPath;
  }

  return navItems.find((item) => item.href.endsWith(`/${selectedSegment}`))?.href ?? defaultPath;
}
